<ng-container *transloco="let t; prefix: 'questions'">
  @if (isMobile$ | async) {
    <mobile-title-image
      [title]="t('getApprovedTitle')"
      [imageName]="eligibilityImage$ | async"
    ></mobile-title-image>
  }
  <div class="content-wrapper">
    <form #myForm="ngForm" [formGroup]="pageForm" (ngSubmit)="submit()" [scrollToErrors]="myForm">
      <!-- SECTION 1 -->
      <section-header [valid]="baseQuestions.valid" [touched]="baseQuestions.touched">{{
        t('propertyQuestion')
      }}</section-header>
      <section-content [formGroup]="baseQuestions">
        <!-- ADDRESS CONTROL -->
        <mat-form-field>
          <mat-label>{{ t('addressLabel') }}</mat-label>
          <ui-address-autocomplete
            placeholder="e.g. 12 Main St, Aptos, CA 95003"
            floatLabel="never"
            e2e-address
            formControlName="address"
            [errorState]="
              baseQuestions.controls.address.invalid &&
              (baseQuestions.controls.address.touched || myForm.submitted)
            "
          ></ui-address-autocomplete>
          @if (
            baseQuestions.controls.address.invalid &&
            (baseQuestions.controls.address.touched || myForm.submitted)
            ) {
            <mat-error
              >
              {{ t('invalidAddressError') }}</mat-error
              >
            }
          </mat-form-field>

          <!-- EMAIL CONTROL -->
          <mat-form-field>
            <mat-label>{{ t('emailLabel') }}</mat-label>
            <input
              matInput
              type="email"
              placeholder="e.g. email@example.com"
              name="text"
              formControlName="email"
              class="main-input"
              e2e-email
              />
            @if (
              baseQuestions.controls.email?.errors?.required ||
              baseQuestions.controls.email?.errors?.pattern
              ) {
              <mat-error
                >
                {{ t('invalidEmailError') }}</mat-error
                >
              }
              @if (
                features.isOff('yt-19374-pace-pause-prequal-updates') &&
                baseQuestions.get('email')?.errors?.emailTaken
                ) {
                <mat-error
                  >
                  {{ t('accountExists') }}
                  <a class="mat-error-link" href="{{ redirectUrl }}">{{ t('loginHere') }}</a>
                </mat-error>
              }
              @if (baseQuestions.get('email')?.errors?.contractorEmail) {
                <mat-error>
                  {{ t('contractorEmailError') }}
                </mat-error>
              }
              @if (baseQuestions.get('email')?.errors?.ygreneEmail) {
                <mat-error>
                  {{ t('ygreneEmailError') }}
                </mat-error>
              }
              @if (baseQuestions.get('email')?.errors?.yopMail) {
                <mat-error>
                  {{ t('yopmailEmailError') }}
                </mat-error>
              }
            </mat-form-field>

            <!-- PHONE CONTROL -->
            <mat-form-field>
              <mat-label>{{ t('phoneLabel') }}</mat-label>
              <input
                matInput
                type="tel"
                placeholder="e.g. 8123458432"
                name="text"
                formControlName="phone"
                [mask]="phoneFormat"
                [dropSpecialCharacters]="false"
                class="main-input"
                e2e-phone
                />
              @if (baseQuestions.controls.phone?.errors?.required) {
                <mat-error>
                  {{ t('invalidBlankPhoneError') }}</mat-error
                  >
                }
                @if (baseQuestions.controls.phone?.errors?.phoneNumber) {
                  <mat-error>{{
                    t('invalidPhoneError')
                  }}</mat-error>
                }
              </mat-form-field>

              <!-- EMAIL OPT IN CONTROL -->
              <mat-checkbox formControlName="email_communication" class="email-communication">
                {{ t('emailCommunicationLabel') }}
              </mat-checkbox>
            </section-content>

            <!-- SECTION 2 -->
            <section-header
              [valid]="pageForm.controls.improvements?.valid"
              [touched]="pageForm.controls.improvements?.touched"
              [optional]="true"
              [optionalText]="t('optionalText')"
              >
              {{ t('improvementQuestion') }}
            </section-header>
            <section-content>
              <select-bubbles
                formControlName="improvements"
                [items]="improvements"
                [translate]="true"
              ></select-bubbles>
            </section-content>

            <!-- SECTION 3 -->
            <section-header
              [valid]="pageForm.controls.timeframes?.valid"
              [touched]="pageForm.controls.timeframes?.touched"
              [optional]="true"
              [optionalText]="t('optionalText')"
              >{{ t('timeFrameQuestion') }}</section-header
              >
              <section-content>
                <select-bubbles
                  formControlName="timeframes"
                  [items]="timeframes"
                  [singleValue]="true"
                  [translate]="true"
                ></select-bubbles>
              </section-content>
            </form>
          </div>

          <div class="footer-wrapper" noShadowOnBottom>
            @if (unsecuredProductPhase2PoFeatureFlag && (!(isMobile$ | async) || !inputFocused)) {
              <div
                class="eligibility-disclaimer"
                >
                {{ t('checkEligibilityDisclaimer') }}
              </div>
            }
            @if (!(isMobile$ | async)) {
              <div class="footer-instruction">
                <span> {{ t('checkEligibilityDisclaimer') }}</span>
              </div>
            }
            <page-footer
      [primary]="{
        label: features.isOn('yt-19374-pace-pause-prequal-updates')
          ? 'Submit'
          : t('checkEligibilityButton'),
        arrow: 'right'
      }"
              [primLoading]="isLoading$ | async"
              (primaryClicked)="myForm.onSubmit()"
              [hidden]="inputFocused"
              [valid]="pageForm.valid && pageForm.touched"
            ></page-footer>
          </div>
        </ng-container>
